import React from "react";

const Contact = () => {
    return <div className="text-center">
           <h2 className="text-xl" > You can email us, our executives will respond in less than 24 hours</h2>  
           <button className="btn"> some@email.com</button>
           <button className="btn">XYZ@gmail.com</button>
          
        </div>
    
}

export default Contact